import React, { PropTypes } from 'react';
import AddButton from '../../AddButton';
import {List, ListItem} from 'material-ui/List';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';

class ClubListCompnonet extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    add: PropTypes.func.isRequired,
    edit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    fetch: PropTypes.func.isRequired
  };

  fakeImg = 'http://placehold.it/32x32';

  componentWillMount() {
    let { loading, fetch } = this.props;
    if (!loading) {
      fetch();
    }
  }

  render() {
    let { items = [], denyAddClub } = this.props;
    return (
      <div>
        <LoggedAppBar
          isStatic={true}
          title="Accounts"
        />
        <List>
            {items.map((item) => (
              <ListItem key={item.id}
                        primaryText={item.name}
                        onClick={() => this.props.edit(item)}
              />
            ))}
        </List>

        {!denyAddClub && <AddButton onClick={this.props.add}/>}
      </div>
    );
  }
}

export default ClubListCompnonet;




// WEBPACK FOOTER //
// ./src/components/Clubs/ClubList/component.jsx